import { Card } from "@doar/components";
import styled, { css, device, themeGet } from "@doar/shared/styled";

export const StyledCard = styled(({ ...rest }) => <Card {...rest} />)`
    @media (min-width: 1600px) {
        width: 75%;
    }
    /* border: none; */
    box-shadow: none;
    width: 100%;
    position: relative;
    border-radius: 5px;
    cursor: pointer;
    ${(props) =>
        props.isOutbound
            ? css`
                  border-top-right-radius: 0;
                  margin-left: auto;
                  &:before {
                      content: "";
                      width: 0;
                      height: 0;
                      border-style: solid;
                      z-index: 1;
                      border-color: #fff transparent transparent transparent;
                      position: absolute;
                      top: 0px;
                      border-width: 13px 16px 0 0;
                      right: -16px;
                  }
                  &:after {
                      content: "";
                      width: 0;
                      height: 0;
                      border-style: solid;
                      border-color: #485e9029 transparent transparent
                          transparent;
                      position: absolute;
                      top: -1px;
                      border-width: 15px 18px 0 0;
                      right: -18px;
                  }
              `
            : css`
                  border-top-left-radius: 0;
                  &:before {
                      content: "";
                      width: 0;
                      height: 0;
                      border-style: solid;
                      z-index: 1;
                      border-width: 0 13px 8px 0;
                      border-color: transparent #fff transparent transparent;
                      position: absolute;
                      left: -13px;
                      top: 0px;
                  }
                  &:after {
                      content: "";
                      width: 0;
                      height: 0;
                      border-style: solid;
                      border-width: 0 15px 10px 0;
                      border-color: transparent #485e9029 transparent
                          transparent;
                      position: absolute;
                      left: -15px;
                      top: -1px;
                  }
              `}
`;

export const StyledThumb = styled.div`
    background-color: ${themeGet("colors.whisper")};
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 36px;
    ${device.small} {
        height: 100px;
        font-size: 40px;
    }
    ${device.large} {
        height: 120px;
        font-size: 48px;
    }
    ${(props) =>
        props.theme.name === "dark" &&
        css`
            background-color: ${themeGet("colors.darkdarken2")};
        `}
`;

export const StyledWrap = styled.div`
    display: flex;
    flex-wrap: wrap;
    grid-column-gap: 10px;
    grid-row-gap: 10px;
`;
